export default __webpack_public_path__ + "static/media/0x5e0294af1732498c77f8db015a2d52a76298542b.94ce6625.webp";